import { formatarNumero_recebido_com_casa_decimais, formatarNumero_recebido_sem_casa_decimais } from "../../../Func_genericas/formatar_numero_formato_pt";

export function formatar_numeros_cabecalho5A(item: any) {
  return {
    ...item,
    area: formatarNumero_recebido_com_casa_decimais(item.area),
    produca_total: formatarNumero_recebido_com_casa_decimais(item.produca_total),
    obtida: formatarNumero_recebido_com_casa_decimais(item.obtida),
    n_planta: formatarNumero_recebido_sem_casa_decimais(item.n_planta)
  };
}


export function formatar_numeros_tabelaExtra_5A(item: any) {
  return {
    ...item,
    elementos_forn_solo_n: formatarNumero_recebido_com_casa_decimais(item.elementos_forn_solo_n),
    elementos_forn_agua_n: formatarNumero_recebido_com_casa_decimais(item.elementos_forn_agua_n),
    totais_aplicados_zona_n: formatarNumero_recebido_com_casa_decimais(item.totais_aplicados_zona_n),
    totais_aplicados_hectare_n: formatarNumero_recebido_com_casa_decimais(item.totais_aplicados_hectare_n),
    elementos_forn_solo_po: formatarNumero_recebido_com_casa_decimais(item.elementos_forn_solo_po),
    elementos_forn_agua_po: formatarNumero_recebido_com_casa_decimais(item.elementos_forn_agua_po),
    totais_aplicados_zona_po: formatarNumero_recebido_com_casa_decimais(item.totais_aplicados_zona_po),
    totais_aplicados_hectare_po: formatarNumero_recebido_com_casa_decimais(item.totais_aplicados_hectare_po),
    elementos_forn_solo_ko: formatarNumero_recebido_com_casa_decimais(item.elementos_forn_solo_ko),
    elementos_forn_agua_ko: formatarNumero_recebido_com_casa_decimais(item.elementos_forn_agua_ko),
    totais_aplicados_zona_ko: formatarNumero_recebido_com_casa_decimais(item.totais_aplicados_zona_ko),
    totais_aplicados_hectare_ko: formatarNumero_recebido_com_casa_decimais(item.totais_aplicados_hectare_ko),
    elementos_forn_solo_mgo: formatarNumero_recebido_com_casa_decimais(item.elementos_forn_solo_mgo),
    elementos_forn_agua_mgo: formatarNumero_recebido_com_casa_decimais(item.elementos_forn_agua_mgo),
    totais_aplicados_zona_mgo: formatarNumero_recebido_com_casa_decimais(item.totais_aplicados_zona_mgo),
    totais_aplicados_hectare_mgo: formatarNumero_recebido_com_casa_decimais(item.totais_aplicados_hectare_mgo),
    elementos_forn_solo_cao: formatarNumero_recebido_com_casa_decimais(item.elementos_forn_solo_cao),
    elementos_forn_agua_cao: formatarNumero_recebido_com_casa_decimais(item.elementos_forn_agua_cao),
    totais_aplicados_zona_cao: formatarNumero_recebido_com_casa_decimais(item.totais_aplicados_zona_cao),
    totais_aplicados_hectare_cao: formatarNumero_recebido_com_casa_decimais(item.totais_aplicados_hectare_cao),
    elementos_forn_solo_so: formatarNumero_recebido_com_casa_decimais(item.elementos_forn_solo_so),
    elementos_forn_agua_so: formatarNumero_recebido_com_casa_decimais(item.elementos_forn_agua_so),
    totais_aplicados_zona_so: formatarNumero_recebido_com_casa_decimais(item.totais_aplicados_zona_so),
    totais_aplicados_hectare_so: formatarNumero_recebido_com_casa_decimais(item.totais_aplicados_hectare_so),
    elementos_forn_solo_b: formatarNumero_recebido_com_casa_decimais(item.elementos_forn_solo_b),
    elementos_forn_agua_b: formatarNumero_recebido_com_casa_decimais(item.elementos_forn_agua_b),
    totais_aplicados_zona_b: formatarNumero_recebido_com_casa_decimais(item.totais_aplicados_zona_b),
    totais_aplicados_hectare_b: formatarNumero_recebido_com_casa_decimais(item.totais_aplicados_hectare_b),
  };
}